import React from "react";
import { cn } from "./cn";
import { WIDE_MEASURE } from "./measure";

/* The gutter every uplifted public page sits in. */
/* Exported so the alignment claim above can be asserted directly rather than
   by walking the rendered DOM. They must stay in step with Header.jsx. */
export const PAGE_GUTTER = "";
export const PAGE_INNER = WIDE_MEASURE;

export const PageContainer = ({ children, className = "", innerClassName = "" }) => (
  /* The two test ids are the sanctioned way to reach a layout element that has
     no role and no text of its own; the alternative is walking the DOM from a
     child, which breaks the moment a wrapper is added. */
  <div data-testid="page-gutter" className={cn(PAGE_GUTTER, className)}>
    <div data-testid="page-inner" className={cn(PAGE_INNER, innerClassName)}>
      {children}
    </div>
  </div>
);

export default PageContainer;
